<template>
    <section class="bg-white container-global q-py-xl">
        <div class="">
            <div class="header_section">
                <span class="header_section-sub-title">
                    حلول متكاملة 
                </span>
                <h3 class="header_section-title">
                    مزايا أداة أكواد                </h3>
                <p class="header_section-description">
                    نقدّم لك تقنيات ذكية لاختبار منتجك الرقمي وجمع ملاحظات المستخدمين وتحليلها واستعراضها بسهولة ووضوح                </p>
            </div>

            <div class="features-slider-container">
                <swiper 
                    :modules="[Autoplay]" 
                    :slides-per-view="1" 
                    :space-between="16"
                    :navigation="false" 
                    :pagination="false" 
                    :autoplay="{
                        delay: 1500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    }" 
                    :loop="true" 
                    :breakpoints="{
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 16,
                            centeredSlides: true
                        },
                        650: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                            centeredSlides: false
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 0
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 0
                        },
                        1200: {
                            slidesPerView: 5,
                            spaceBetween: 0
                        }
                    }" 
                    class="features-swiper">
                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_1.svg" alt="User Research" />
                            </div>
                            <h4 class="feature-title">قوالب اختبارات جاهزة</h4>
                            <p class="feature-description">اختبارك جاهز! فقط اختر موقعك الإلكتروني وحدد معايير
                                التقييم</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_2.svg" alt="Performance Testing" />
                            </div>
                            <h4 class="feature-title">تقارير تفصيلية</h4>
                            <p class="feature-description">استعراض التحديات وفرص التحسين بطريقة تفصيلية وتحليلية</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_3.svg" alt="User Experience" />
                            </div>
                            <h4 class="feature-title">بدون تدخل تقني</h4>
                            <p class="feature-description">اختبر موقعك مباشرة على البيئة الحيّة بدون تعقيد وبدون أي
                                برمجيات
                            </p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_4.svg" alt="Analytics" />
                            </div>
                            <h4 class="feature-title">الذكاء الاصطناعي</h4>
                            <p class="feature-description">تقدر تطلب منه يلخص لك آراء 1000+ مستخدم في 3 سطور</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_5.svg" alt="Analytics" />
                            </div>
                            <h4 class="feature-title">اختبارات الحشود</h4>
                            <p class="feature-description">اختبر موقعك تحت ضغط عدد كبير من الزوار وتأكد من كفاءة
                                الأداء</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_6.svg" alt="Analytics" />
                            </div>
                            <h4 class="feature-title">مدة الجلسة</h4>
                            <p class="feature-description">تعرف على الفترة المستغرقة لكل مستخدم، ومتوسط الجلسة لجميع
                                المستخدمين</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_7.svg" alt="Analytics" />
                            </div>
                            <h4 class="feature-title"> نقاط الانسحاب</h4>
                            <p class="feature-description">تحديد الصفحات اللي يوقف عندها المستخدم ويطلع من موقعك</p>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <img src="@/assets/images/new-home/features_8.svg" alt="Analytics" />
                            </div>
                            <h4 class="feature-title">تحديد الملاحظات السلبية</h4>
                            <p class="feature-description">يساعدك على الوصول للملاحظات البنّاءة واكتشاف فرص التحسين
                            </p>
                        </div>
                    </SwiperSlide>
                </swiper>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
</script>

<style scoped lang="scss">


.features-slider-container {
    margin-top: 60px;
    position: relative;

    .features-swiper {
        padding: 20px 0 60px 0;

        :deep(.swiper-slide) {
            padding: 0 8px;
            height: auto;
        }
    }

    :deep(.swiper-pagination) {
        bottom: 20px;
    }

    :deep(.swiper-pagination-bullet) {
        background: #ddd;
        opacity: 1;
        width: 12px;
        height: 12px;
        transition: all 0.3s ease;
    }

    :deep(.swiper-pagination-bullet-active) {
        background: #5854ff;
    }

    @media (max-width: 768px) {
        padding: 0 10px;

        .features-swiper {
            padding: 15px 0 50px 0;

            :deep(.swiper-slide) {
                padding: 0 4px;
            }
        }
    }

    @media (max-width: 650px) {
        padding: 0;

        .features-swiper {
            padding: 15px 0 50px 0;

            :deep(.swiper-slide) {
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    @media (max-width: 480px) {
        padding: 0;

        .features-swiper {

            :deep(.swiper-slide) {
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}

.feature-card {
    background: #fff;
    border: 1px solid #EFEFF2;
    border-radius: 20px;
    box-shadow: 0 2px 8px 0 rgba(88, 84, 255, 0.04);
    padding: 32px 24px;
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    // width: 100%;
    min-height: 260px;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px 0 rgba(88, 84, 255, 0.1);
    }

    @media (max-width: 650px) {
        padding: 28px 20px;
        min-height: 240px;
        width: 85%;
        max-width: 320px;
        margin: 0 auto;
    }

    @media (max-width: 480px) {
        padding: 24px 16px;
        min-height: 220px;
        width: 90%;
        max-width: 280px;
    }
}

.feature-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: #F6F5FF;
    // border-radius: 50%;

    img {
        width: 44px;
        height: 44px;
    }
}

.feature-title {
    color: var(--bs-text-color);
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 16px 0;
    line-height: 1.3;
}

.feature-description {
    color: var(--bs-text-color-secondary);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    margin: 0;
}

@media (max-width: 768px) {
    .features-slider-container {
        margin-top: 40px;
    }

    .feature-card {
        padding: 24px 20px;
    }

    .feature-icon {
        width: 70px;
        height: 70px;
        margin-bottom: 20px;

        img {
            width: 38px;
            height: 38px;
        }
    }

    .feature-title {
        font-size: 20px;
        margin-bottom: 12px;
    }

    .feature-description {
        font-size: 15px;
    }
}

@media (max-width: 480px) {
    .features-slider-container {
        margin-top: 30px;
    }

    .feature-card {
        padding: 20px 16px;
        min-height: 200px;
    }

    .feature-icon {
        width: 60px;
        height: 60px;
        margin-bottom: 16px;

        img {
            width: 32px;
            height: 32px;
        }
    }

    .feature-title {
        font-size: 18px;
        margin-bottom: 10px;
    }

    .feature-description {
        font-size: 14px;
        line-height: 1.4;
    }
}
</style>